import { createStore } from "vuex";
import * as getters from "@/store/getters";
import actions from "@/store/actions";
import mutations from "@/store/mutations";
import envConfig from "@/config/env.config.json";

const state = {
  envConfig: envConfig[process.env.NODE_ENV],

  // User
  currentUser: null,
  currentUserProfile: null,
  currentUsersDevices: null,
  relationships: null,
  specialties: null,

  // Share History
  shareHistory: null,
  postShareHistory: null,

  // Readings
  latestReadingsForDevice: null,
  isLatestReadingToday: null,
  readingsForGLUCOMETER: null,
  readingsForSCALE: null,
  readingsForBP_CUFF: null,
  readingsForTHERMOMETER: null,
  readingsForPULSE_OXIMETER: null,

  // Wordle
  allWordleWords: null,
  attemptedWord: null,
  bestStreak: null,
  currentGuessIndex: 0,
  currentRow: 1,
  currentStreak: null,
  found: new Set(),
  gameRecord: null,
  gameWon: null,
  getAllGuessedWords: null,
  guesses: Array(6).fill(""),
  hint: new Set(),
  letterBoxColors: {},
  miss: new Set(),
  playingGame: null,
  previousGameRecord: null,
  solution: null,
  wordleGame: null,
  wordleGameId: null,
  wordleGameSaved: null,
  wordleWordId: null,
  wordleWordRow: null,
};
const store = createStore({
  state,
  getters,
  actions,
  mutations,
});

// When in dev mode, reload getters, actions, and mutations when those files are saved/updated
if (module.hot) {
  module.hot.accept(["./getters", "./actions", "./mutations"], () => {
    store.hotUpdate({
      getters: require("./getters"),
      actions: require("./actions"),
      mutations: require("./mutations"),
    });
  });
}

export default store;
